export interface IWatrLimit {
    id: number,
    wageWeeklyLimit: number, 
    derReimbursementLimit: number,
    organType: number,
    roundTrips: number,
    donorRoundTrips: number,
    caregiverRoundTrips: number,
    transportationExpenses: number,
    mileage: number,
    meals: number,
    hotelNights: number,
    dependentCare: number,
    effectiveDateTime: Date,
    createdDateTime: Date
}